import { Skeleton } from '@mantine/core';

import classes from './Skeleton.module.css';

const SkeletonDefaultProps = {};

const SkeletonDefaults = Skeleton.extend({
  defaultProps: SkeletonDefaultProps,
  classNames: {
    root: classes.root,
  },
});

export { Skeleton, SkeletonDefaults };
